import { Button, Typography } from '@mui/material'
import _ from 'lodash'
import PropTypes from 'prop-types'
import { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import request from '~/apis/request'
import { loadingStates, paymentTypes } from '~/config/constant'
import { MERCHANT_TYPE, keywordScreen } from '~/constants'
import STORAGE_KEYS from '~/constants/localStorage'
import { useAppContext } from '~/contexts/AppContext'
import { clearAllCart } from '~/redux/cartSlice'
import { selectRestaurant } from '~/redux/restaurantSlice'
import { path, route } from '~/routes/path'
import { variantStyles } from '~/theme/constants'
import { isValidArray } from '~/utils'
import { getMessageOrderError, transformToppings } from '~/utils/order'

const ButtonOrder = (props) => {
  const { data, title, style, callback, setMessage, setIdErrorOrder, setShowPopupError } = props
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const [loadingSubmit, setLoadingSubmit] = useState(false)

  const { restaurantId, tableId, paymentType, food_court_id, merchant_type } =
    useSelector(selectRestaurant)
  const isTypeSouvenir = merchant_type === MERCHANT_TYPE.SOUVENIR

  const { saveServingSessionID, setIsNotify } = useAppContext()

  const formattedData = () => {
    if (data.length <= 0) return null
    return data.map((foodItem) => {
      const { id, quantity, price, note, foodOptionTypes, is_buffet_item } = foodItem
      const newItem = {
        kind: is_buffet_item ? 'buffet_item_order' : 'food_order',
        food_item_id: id,
        quantity,
        price,
        note,
      }
      // nếu có topping
      if (isValidArray(foodOptionTypes)) {
        newItem.requests_food_options_attributes = transformToppings(foodOptionTypes)
      }
      return newItem
    })
  }

  // Hàm di chuyển đến màn hình thành công tuỳ thuộc vào điều kiện
  const navigateToSuccessScreen = () => {
    const URL = isTypeSouvenir
      ? path.orderPlacedSouvenir
      : `${route.confirmedPayment}/${keywordScreen.ordering}`

    navigate(URL)
  }

  const onSubmit = async () => {
    setMessage('')

    // Trong trường hợp food court thì sẽ di chuyển đến màn hình ordering
    if (food_court_id) {
      navigate(path.orderingFoodCourt)
      return
    }

    // Trong trường hợp là payment in advance thì di chuyển đến màn hình chọn phương thức thanh toán luôn
    if (paymentType === paymentTypes.pay_in_advance) {
      navigate(path.choosePaymentMethod)
      return
    }

    // Trong trường hợp là souvenior thì sẽ đổi url khác.
    const URL = isTypeSouvenir
      ? `/restaurants/${restaurantId}/requests`
      : `/restaurants/${restaurantId}/tables/${tableId}/requests`

    if (loadingSubmit) return

    setLoadingSubmit(true)

    try {
      const response = await request().post(URL, {
        requests: formattedData() || [],
        number_of_people: Number(localStorage.getItem(STORAGE_KEYS.NUMBER_OF_PEOPLE)),
      })
      if (response?.data?.status === loadingStates.success) {
        dispatch(clearAllCart())
        navigateToSuccessScreen()

        if (isTypeSouvenir) {
          setIsNotify(true) // vì đối với souvenir thì khi tạo request trạng thái sẽ là confirm luôn
        }

        if (response.data?.serving_session_id) {
          saveServingSessionID(response.data.serving_session_id)
        }
      }
    } catch (error) {
      setMessage(getMessageOrderError(error))
      if (error.response.data?.item_error_id) {
        setIdErrorOrder(error.response.data?.item_error_id)
        setShowPopupError(true)
      }
    } finally {
      callback()
    }

    setLoadingSubmit(false)
  }

  const debounceSubmit = _.debounce(() => {
    onSubmit()
  }, 300)

  return (
    <Button
      disabled={loadingSubmit}
      onClick={debounceSubmit}
      variant={variantStyles.btnOrder}
      style={style}>
      <Typography color="baseColor.colorText3">{title}</Typography>
    </Button>
  )
}

ButtonOrder.defaultProps = {
  data: [],
  title: 'Order',
  style: {},
  callback: () => {},
  setMessage: () => {},
}

ButtonOrder.propTypes = {
  data: PropTypes.array,
  title: PropTypes.string.isRequired,
  style: PropTypes.object,
  callback: PropTypes.func,
  setMessage: PropTypes.func,
  setIdErrorOrder: PropTypes.func,
  setShowPopupError: PropTypes.func,
}

export default ButtonOrder
